<template>
  <div class="schedule" v-if="promotion && promotion.schedule">
    <ToggleSwitch v-model="showSchedule" class="thin">
      <div>{{ $t('promotion_new.schedule_add') }}</div>
      <div class="toggle-description">{{ $t('promotion_new.schedule_add_description') }}</div>
    </ToggleSwitch>
    <br>
    <div class="columns" :class="{locked: !showSchedule}">
      <div class="column">
        <DayTimeRange v-for="(day, dayIndex) in promotion.schedule.slice(0,4)"
                      :key="dayIndex" :day="day" :dayName="day.name"></DayTimeRange>
      </div>
      <div class="column">
        <DayTimeRange v-for="(day, dayIndex) in promotion.schedule.slice(4, 7)"
                      :key="dayIndex" :day="day" :dayName="day.name"></DayTimeRange>
      </div>
    </div>
  </div>
</template>

<script>
import ToggleSwitch from "@/components/tools/ToggleSwitch";
import DayTimeRange from "@/components/tools/DayTimeRange";

export default {
  name: "PromotionSchedule",

  components: { ToggleSwitch, DayTimeRange },

  props: {
    promotion: Object
  },

  data() {
    return {
      showSchedule: false
    }
  },

  computed: {
    isPromotionScheduleEmpty() {
      if (!this.promotion.schedule) {
        return true;
      }
      let notEmptyDays = this.promotion.schedule.filter(d =>
          d.hours.length > 0 && d.hours.filter(h => !!h.from || !!h.to).length > 0);
      return notEmptyDays.length === 0;
    },
  },

  mounted() {
    if (!this.promotion.schedule) {
      this.createSchedule();
    }
    this.showSchedule = !this.isPromotionScheduleEmpty;
  },

  methods: {
    createSchedule() {
      this.promotion.schedule = [
        { name: "monday", hours: [] },
        { name: "tuesday", hours: [] },
        { name: "wednesday", hours: [] },
        { name: "thursday", hours: [] },
        { name: "friday", hours: [] },
        { name: "saturday", hours: [] },
        { name: "sunday", hours: [] }
      ]
    }
  }
}
</script>